import ButtonPrimary from '../../ButtonPrimary'

const ButtonPrimaryBlock = ({
  title,
  disabled = false,
  loading = false,
  onClick = () => {},
  tooltipTitle = '',
  ...props
}) => {
  return (
    <ButtonPrimary
      {...props}
      block
      title={title}
      disabled={disabled}
      loading={loading}
      onClick={onClick}
      tooltipTitle={tooltipTitle}
    />
  )
}

export default ButtonPrimaryBlock
